import { Reducer } from 'redux';
import { FinancialState, FinancialTypes } from './types';

const INITIAL_STATE: FinancialState = {
  pagination: undefined,
  data: [],
  loading: false,
};

const reducer: Reducer<FinancialState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FinancialTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FinancialTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload,
      };
    case FinancialTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
